// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"7ae64242","67":"ddd0122b","274":"44e7477d","297":"f5635d2c","324":"35c5c9eb","333":"7b51a235","399":"69abba6f","673":"a63245b9","680":"3b170e6b","681":"b562af49","770":"a64df566"}[chunkId] + ".chunk.css";
};